<template>
  <div>
    <header>
      <img src="@/assets/logo.png" alt="Logo"> <!-- Updated the path to use '@' alias -->
      <span class="tagline">CLI Grand Central</span>
    </header>
    <main>
      <SearchBar @selectFile="handleFileSelection" :defaultSearch="defaultSearch" />
      <router-view></router-view>
    </main>
    <footer>
      &copy; <span id="year"></span> | For Contact <a href="mailto:proc@awk.fyi">proc@awk.fyi</a>
    </footer>
  </div>
</template>

<script>
import SearchBar from '@/components/SearchBar.vue';
import axios from 'axios';
import markdownIt from 'markdown-it';

const md = new markdownIt();

export default {
  name: 'App',
  components: {
    SearchBar
  },
  data() {
    return {
      selectedFileContent: '',
      defaultSearch: 'awk'
    };
  },
  methods: {
    async handleFileSelection(fileName) {
      console.log('File selected:', fileName); // Log the selected file name
      try {
        const response = await axios.get(`/md/linux-commands/${fileName}.md`); // Ensure .md extension is included
        const content = response.data;
        const htmlContent = md.render(content);
        this.selectedFileContent = htmlContent;
      } catch (error) {
        console.error('Error fetching file content:', error);
      }
    }
  },
  mounted() {
    document.getElementById("year").textContent = new Date().getFullYear();
    console.log('App.vue mounted');
  }
}
</script>

<style>
body {
  font-family: 'Space Mono', monospace;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch; /* Ensures full width */
  background-color: #fafafa;
  color: #333;
}
header {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 10px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
}
header img {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  margin-bottom: 5px;
}
header .tagline {
  font-size: 14px;
  color: #888;
  font-weight: bold;
}
main {
  max-width: 800px;
  width: 100%;
  padding: 20px;
  text-align: left; /* Ensures left alignment */
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 20px auto; /* Centers the main block horizontally */
  border-radius: 8px;
}
h1 a {
  color: #3498db;
  text-decoration: none;
}
h1 a:hover {
  text-decoration: underline;
}
h2 {
  color: #2c3e50;
}
pre {
  background-color: #2d2d2d;
  color: #f8f8f2;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
  position: relative;
}
pre code {
  font-family: 'Space Mono', monospace;
}
.copy-icon {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #3498db;
  color: #fff;
  border: none;
  cursor: pointer;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.copied {
  background: #28a745;
}
footer {
  margin-top: auto;
  padding: 20px;
  background-color: #fff;
  width: 100%;
  text-align: center;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
}
</style>
